/**
 * components/landing/ai-platform/sections/Vision.jsx — §4.2.
 * Five principles — assist, understand, learn, reduce, decide.
 */

import React from 'react'
import { HandHeart, Compass, BookOpen, Zap, ShieldCheck, Sparkles } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { VISION } from '../data'
import { TONE } from '../_shared'

const ICONS = { HandHeart, Compass, BookOpen, Zap, ShieldCheck }

export default function Vision() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>AI Vision</Eyebrow>
          <SectionHeading
            align="center"
            title={<>Practical AI. <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">Not hype.</span></>}
            subtitle="Five principles that shape every AI capability we ship. Read them as our contract with you — what we’ll do, and what we won’t."
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {VISION.map((v) => {
            const tone = TONE[v.tone] || TONE.orange
            const Icon = ICONS[v.iconKey] || Sparkles
            return (
              <div key={v.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex flex-col gap-3">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 16, height: 16 }} />
                  </span>
                  <div>
                    <h4 className="text-[13.5px] font-semibold text-white leading-snug">{v.label}</h4>
                    <p className="text-[12.5px] text-zinc-400 leading-relaxed mt-1.5">{v.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
